// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tT8LB","right":"styles_right__2kGEC"};